/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { tidy, util, Tensor, dispose, ENV } from "@tensorflow/tfjs-core";
import nodeFetch from "node-fetch";

var _extendStatics = function extendStatics(t, r) {
  return (_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (t, r) {
    t.__proto__ = r;
  } || function (t, r) {
    for (var e in r) {
      r.hasOwnProperty(e) && (t[e] = r[e]);
    }
  })(t, r);
};

function __extends(t, r) {
  function e() {
    this.constructor = t;
  }

  _extendStatics(t, r), t.prototype = null === r ? Object.create(r) : (e.prototype = r.prototype, new e());
}

function __awaiter(t, r, e, n) {
  return new (e || (e = Promise))(function (o, i) {
    function s(t) {
      try {
        u(n.next(t));
      } catch (t) {
        i(t);
      }
    }

    function a(t) {
      try {
        u(n.throw(t));
      } catch (t) {
        i(t);
      }
    }

    function u(t) {
      t.done ? o(t.value) : new e(function (r) {
        r(t.value);
      }).then(s, a);
    }

    u((n = n.apply(t, r || [])).next());
  });
}

function __generator(t, r) {
  var e,
      n,
      o,
      i,
      s = {
    label: 0,
    sent: function sent() {
      if (1 & o[0]) throw o[1];
      return o[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: a(0),
    throw: a(1),
    return: a(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;

  function a(i) {
    return function (a) {
      return function (i) {
        if (e) throw new TypeError("Generator is already executing.");

        for (; s;) {
          try {
            if (e = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

            switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
              case 0:
              case 1:
                o = i;
                break;

              case 4:
                return s.label++, {
                  value: i[1],
                  done: !1
                };

              case 5:
                s.label++, n = i[1], i = [0];
                continue;

              case 7:
                i = s.ops.pop(), s.trys.pop();
                continue;

              default:
                if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                  s = 0;
                  continue;
                }

                if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                  s.label = i[1];
                  break;
                }

                if (6 === i[0] && s.label < o[1]) {
                  s.label = o[1], o = i;
                  break;
                }

                if (o && s.label < o[2]) {
                  s.label = o[2], s.ops.push(i);
                  break;
                }

                o[2] && s.ops.pop(), s.trys.pop();
                continue;
            }

            i = r.call(t, s);
          } catch (t) {
            i = [6, t], n = 0;
          } finally {
            e = o = 0;
          }
        }

        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, a]);
    };
  }
}

var commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function unwrapExports(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}

function createCommonjsModule(t, r) {
  return t(r = {
    exports: {}
  }, r.exports), r.exports;
}

var alea = createCommonjsModule(function (t) {
  !function (t, r, e) {
    function n(t, r) {
      return r.c = t.c, r.s0 = t.s0, r.s1 = t.s1, r.s2 = t.s2, r;
    }

    function o(t, r) {
      var e = new function (t) {
        var r,
            e = this,
            n = (r = 4022871197, function (t) {
          t = t.toString();

          for (var e = 0; e < t.length; e++) {
            var n = .02519603282416938 * (r += t.charCodeAt(e));
            n -= r = n >>> 0, r = (n *= r) >>> 0, r += 4294967296 * (n -= r);
          }

          return 2.3283064365386963e-10 * (r >>> 0);
        });
        e.next = function () {
          var t = 2091639 * e.s0 + 2.3283064365386963e-10 * e.c;
          return e.s0 = e.s1, e.s1 = e.s2, e.s2 = t - (e.c = 0 | t);
        }, e.c = 1, e.s0 = n(" "), e.s1 = n(" "), e.s2 = n(" "), e.s0 -= n(t), e.s0 < 0 && (e.s0 += 1), e.s1 -= n(t), e.s1 < 0 && (e.s1 += 1), e.s2 -= n(t), e.s2 < 0 && (e.s2 += 1), n = null;
      }(t),
          o = r && r.state,
          i = e.next;
      return i.int32 = function () {
        return 4294967296 * e.next() | 0;
      }, i.double = function () {
        return i() + 1.1102230246251565e-16 * (2097152 * i() | 0);
      }, i.quick = i, o && ("object" == typeof o && n(o, e), i.state = function () {
        return n(e, {});
      }), i;
    }

    r && r.exports ? r.exports = o : e && e.amd ? e(function () {
      return o;
    }) : this.alea = o;
  }(0, t, !1);
}),
    xor128 = createCommonjsModule(function (t) {
  !function (t, r, e) {
    function n(t, r) {
      return r.x = t.x, r.y = t.y, r.z = t.z, r.w = t.w, r;
    }

    function o(t, r) {
      var e = new function (t) {
        var r = this,
            e = "";
        r.x = 0, r.y = 0, r.z = 0, r.w = 0, r.next = function () {
          var t = r.x ^ r.x << 11;
          return r.x = r.y, r.y = r.z, r.z = r.w, r.w ^= r.w >>> 19 ^ t ^ t >>> 8;
        }, t === (0 | t) ? r.x = t : e += t;

        for (var n = 0; n < e.length + 64; n++) {
          r.x ^= 0 | e.charCodeAt(n), r.next();
        }
      }(t),
          o = r && r.state,
          i = function i() {
        return (e.next() >>> 0) / 4294967296;
      };

      return i.double = function () {
        do {
          var t = ((e.next() >>> 11) + (e.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);

        return t;
      }, i.int32 = e.next, i.quick = i, o && ("object" == typeof o && n(o, e), i.state = function () {
        return n(e, {});
      }), i;
    }

    r && r.exports ? r.exports = o : e && e.amd ? e(function () {
      return o;
    }) : this.xor128 = o;
  }(0, t, !1);
}),
    xorwow = createCommonjsModule(function (t) {
  !function (t, r, e) {
    function n(t, r) {
      return r.x = t.x, r.y = t.y, r.z = t.z, r.w = t.w, r.v = t.v, r.d = t.d, r;
    }

    function o(t, r) {
      var e = new function (t) {
        var r = this,
            e = "";
        r.next = function () {
          var t = r.x ^ r.x >>> 2;
          return r.x = r.y, r.y = r.z, r.z = r.w, r.w = r.v, (r.d = r.d + 362437 | 0) + (r.v = r.v ^ r.v << 4 ^ t ^ t << 1) | 0;
        }, r.x = 0, r.y = 0, r.z = 0, r.w = 0, r.v = 0, t === (0 | t) ? r.x = t : e += t;

        for (var n = 0; n < e.length + 64; n++) {
          r.x ^= 0 | e.charCodeAt(n), n == e.length && (r.d = r.x << 10 ^ r.x >>> 4), r.next();
        }
      }(t),
          o = r && r.state,
          i = function i() {
        return (e.next() >>> 0) / 4294967296;
      };

      return i.double = function () {
        do {
          var t = ((e.next() >>> 11) + (e.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);

        return t;
      }, i.int32 = e.next, i.quick = i, o && ("object" == typeof o && n(o, e), i.state = function () {
        return n(e, {});
      }), i;
    }

    r && r.exports ? r.exports = o : e && e.amd ? e(function () {
      return o;
    }) : this.xorwow = o;
  }(0, t, !1);
}),
    xorshift7 = createCommonjsModule(function (t) {
  !function (t, r, e) {
    function n(t, r) {
      return r.x = t.x.slice(), r.i = t.i, r;
    }

    function o(t, r) {
      null == t && (t = +new Date());

      var e = new function (t) {
        var r = this;
        r.next = function () {
          var t,
              e,
              n = r.x,
              o = r.i;
          return t = n[o], e = (t ^= t >>> 7) ^ t << 24, e ^= (t = n[o + 1 & 7]) ^ t >>> 10, e ^= (t = n[o + 3 & 7]) ^ t >>> 3, e ^= (t = n[o + 4 & 7]) ^ t << 7, t = n[o + 7 & 7], e ^= (t ^= t << 13) ^ t << 9, n[o] = e, r.i = o + 1 & 7, e;
        }, function (t, r) {
          var e,
              n = [];
          if (r === (0 | r)) n[0] = r;else for (r = "" + r, e = 0; e < r.length; ++e) {
            n[7 & e] = n[7 & e] << 15 ^ r.charCodeAt(e) + n[e + 1 & 7] << 13;
          }

          for (; n.length < 8;) {
            n.push(0);
          }

          for (e = 0; e < 8 && 0 === n[e]; ++e) {
            ;
          }

          for (8 == e ? n[7] = -1 : n[e], t.x = n, t.i = 0, e = 256; e > 0; --e) {
            t.next();
          }
        }(r, t);
      }(t),
          o = r && r.state,
          i = function i() {
        return (e.next() >>> 0) / 4294967296;
      };

      return i.double = function () {
        do {
          var t = ((e.next() >>> 11) + (e.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);

        return t;
      }, i.int32 = e.next, i.quick = i, o && (o.x && n(o, e), i.state = function () {
        return n(e, {});
      }), i;
    }

    r && r.exports ? r.exports = o : e && e.amd ? e(function () {
      return o;
    }) : this.xorshift7 = o;
  }(0, t, !1);
}),
    xor4096 = createCommonjsModule(function (t) {
  !function (t, r, e) {
    function n(t, r) {
      return r.i = t.i, r.w = t.w, r.X = t.X.slice(), r;
    }

    function o(t, r) {
      null == t && (t = +new Date());

      var e = new function (t) {
        var r = this;
        r.next = function () {
          var t,
              e,
              n = r.w,
              o = r.X,
              i = r.i;
          return r.w = n = n + 1640531527 | 0, e = o[i + 34 & 127], t = o[i = i + 1 & 127], e ^= e << 13, t ^= t << 17, e ^= e >>> 15, t ^= t >>> 12, e = o[i] = e ^ t, r.i = i, e + (n ^ n >>> 16) | 0;
        }, function (t, r) {
          var e,
              n,
              o,
              i,
              s,
              a = [],
              u = 128;

          for (r === (0 | r) ? (n = r, r = null) : (r += "\0", n = 0, u = Math.max(u, r.length)), o = 0, i = -32; i < u; ++i) {
            r && (n ^= r.charCodeAt((i + 32) % r.length)), 0 === i && (s = n), n ^= n << 10, n ^= n >>> 15, n ^= n << 4, n ^= n >>> 13, i >= 0 && (s = s + 1640531527 | 0, o = 0 == (e = a[127 & i] ^= n + s) ? o + 1 : 0);
          }

          for (o >= 128 && (a[127 & (r && r.length || 0)] = -1), o = 127, i = 512; i > 0; --i) {
            n = a[o + 34 & 127], e = a[o = o + 1 & 127], n ^= n << 13, e ^= e << 17, n ^= n >>> 15, e ^= e >>> 12, a[o] = n ^ e;
          }

          t.w = s, t.X = a, t.i = o;
        }(r, t);
      }(t),
          o = r && r.state,
          i = function i() {
        return (e.next() >>> 0) / 4294967296;
      };

      return i.double = function () {
        do {
          var t = ((e.next() >>> 11) + (e.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);

        return t;
      }, i.int32 = e.next, i.quick = i, o && (o.X && n(o, e), i.state = function () {
        return n(e, {});
      }), i;
    }

    r && r.exports ? r.exports = o : e && e.amd ? e(function () {
      return o;
    }) : this.xor4096 = o;
  }(0, t, !1);
}),
    tychei = createCommonjsModule(function (t) {
  !function (t, r, e) {
    function n(t, r) {
      return r.a = t.a, r.b = t.b, r.c = t.c, r.d = t.d, r;
    }

    function o(t, r) {
      var e = new function (t) {
        var r = this,
            e = "";
        r.next = function () {
          var t = r.b,
              e = r.c,
              n = r.d,
              o = r.a;
          return t = t << 25 ^ t >>> 7 ^ e, e = e - n | 0, n = n << 24 ^ n >>> 8 ^ o, o = o - t | 0, r.b = t = t << 20 ^ t >>> 12 ^ e, r.c = e = e - n | 0, r.d = n << 16 ^ e >>> 16 ^ o, r.a = o - t | 0;
        }, r.a = 0, r.b = 0, r.c = -1640531527, r.d = 1367130551, t === Math.floor(t) ? (r.a = t / 4294967296 | 0, r.b = 0 | t) : e += t;

        for (var n = 0; n < e.length + 20; n++) {
          r.b ^= 0 | e.charCodeAt(n), r.next();
        }
      }(t),
          o = r && r.state,
          i = function i() {
        return (e.next() >>> 0) / 4294967296;
      };

      return i.double = function () {
        do {
          var t = ((e.next() >>> 11) + (e.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);

        return t;
      }, i.int32 = e.next, i.quick = i, o && ("object" == typeof o && n(o, e), i.state = function () {
        return n(e, {});
      }), i;
    }

    r && r.exports ? r.exports = o : e && e.amd ? e(function () {
      return o;
    }) : this.tychei = o;
  }(0, t, !1);
}),
    seedrandom = createCommonjsModule(function (t) {
  !function (r, e) {
    var n,
        o = (0, eval)("this"),
        i = 256,
        s = 6,
        a = "random",
        u = e.pow(i, s),
        h = e.pow(2, 52),
        c = 2 * h,
        l = i - 1;

    function f(t, f, v) {
      var m = [],
          w = d(function t(r, e) {
        var n,
            o = [],
            i = typeof r;
        if (e && "object" == i) for (n in r) {
          try {
            o.push(t(r[n], e - 1));
          } catch (t) {}
        }
        return o.length ? o : "string" == i ? r : r + "\0";
      }((f = 1 == f ? {
        entropy: !0
      } : f || {}).entropy ? [t, y(r)] : null == t ? function () {
        try {
          var t;
          return n && (t = n.randomBytes) ? t = t(i) : (t = new Uint8Array(i), (o.crypto || o.msCrypto).getRandomValues(t)), y(t);
        } catch (t) {
          var e = o.navigator,
              s = e && e.plugins;
          return [+new Date(), o, s, o.screen, y(r)];
        }
      }() : t, 3), m),
          _ = new function (t) {
        var r,
            e = t.length,
            n = this,
            o = 0,
            s = n.i = n.j = 0,
            a = n.S = [];
        e || (t = [e++]);

        for (; o < i;) {
          a[o] = o++;
        }

        for (o = 0; o < i; o++) {
          a[o] = a[s = l & s + t[o % e] + (r = a[o])], a[s] = r;
        }

        (n.g = function (t) {
          for (var r, e = 0, o = n.i, s = n.j, a = n.S; t--;) {
            r = a[o = l & o + 1], e = e * i + a[l & (a[o] = a[s = l & s + r]) + (a[s] = r)];
          }

          return n.i = o, n.j = s, e;
        })(i);
      }(m),
          g = function g() {
        for (var t = _.g(s), r = u, e = 0; t < h;) {
          t = (t + e) * i, r *= i, e = _.g(1);
        }

        for (; t >= c;) {
          t /= 2, r /= 2, e >>>= 1;
        }

        return (t + e) / r;
      };

      return g.int32 = function () {
        return 0 | _.g(4);
      }, g.quick = function () {
        return _.g(4) / 4294967296;
      }, g.double = g, d(y(_.S), r), (f.pass || v || function (t, r, n, o) {
        return o && (o.S && p(o, _), t.state = function () {
          return p(_, {});
        }), n ? (e[a] = t, r) : t;
      })(g, w, "global" in f ? f.global : this == e, f.state);
    }

    function p(t, r) {
      return r.i = t.i, r.j = t.j, r.S = t.S.slice(), r;
    }

    function d(t, r) {
      for (var e, n = t + "", o = 0; o < n.length;) {
        r[l & o] = l & (e ^= 19 * r[l & o]) + n.charCodeAt(o++);
      }

      return y(r);
    }

    function y(t) {
      return String.fromCharCode.apply(0, t);
    }

    if (e["seed" + a] = f, d(e.random(), r), t.exports) {
      t.exports = f;

      try {
        n = require("crypto");
      } catch (t) {}
    } else 0;
  }([], Math);
});
seedrandom.alea = alea, seedrandom.xor128 = xor128, seedrandom.xorwow = xorwow, seedrandom.xorshift7 = xorshift7, seedrandom.xor4096 = xor4096, seedrandom.tychei = tychei;
var seedrandom$1 = seedrandom,
    seedrandom_1 = seedrandom$1.alea,
    util$1 = createCommonjsModule(function (t, r) {
  function e(t) {
    for (var r = t.length, e = 0, n = 0; r > 0;) {
      n = Math.random() * r | 0, e = t[--r], t[r] = t[n], t[n] = e;
    }
  }

  function n(t, r) {
    if (!t) throw new Error("string" == typeof r ? r : r());
  }

  function o(t, r) {
    if (void 0 === r && (r = []), Array.isArray(t)) for (var e = 0; e < t.length; ++e) {
      o(t[e], r);
    } else r.push(t);
    return r;
  }

  function i(t, r) {
    if (t === r) return !0;
    if (null == t || null == r) return !1;
    if (t.length !== r.length) return !1;

    for (var e = 0; e < t.length; e++) {
      if (t[e] !== r[e]) return !1;
    }

    return !0;
  }

  function s(t, r) {
    if ("float32" !== r) for (var e = 0; e < t.length; e++) {
      if (isNaN(t[e])) throw Error("NaN is not a valid value for dtype: '" + r + "'.");
    }
  }

  function a(t) {
    return "string" == typeof t || t instanceof String;
  }

  function u(t) {
    return "boolean" == typeof t;
  }

  function h(t) {
    return "number" == typeof t;
  }

  function c(t, r) {
    if (null == r || "float32" === r || "complex64" === r) return new Float32Array(t);
    if ("int32" === r) return new Int32Array(t);
    if ("bool" === r) return new Uint8Array(t);
    throw new Error("Unknown data type " + r);
  }

  function l(t) {
    for (; t instanceof Array;) {
      t = t[0];
    }

    return t;
  }

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.shuffle = e, r.clamp = function (t, r, e) {
    return Math.max(t, Math.min(r, e));
  }, r.nearestLargerEven = function (t) {
    return t % 2 == 0 ? t : t + 1;
  }, r.sum = function (t) {
    for (var r = 0, e = 0; e < t.length; e++) {
      r += t[e];
    }

    return r;
  }, r.randUniform = function (t, r) {
    var e = Math.random();
    return r * e + (1 - e) * t;
  }, r.distSquared = function (t, r) {
    for (var e = 0, n = 0; n < t.length; n++) {
      var o = Number(t[n]) - Number(r[n]);
      e += o * o;
    }

    return e;
  }, r.assert = n, r.assertShapesMatch = function (t, r, e) {
    void 0 === e && (e = ""), n(i(t, r), e + " Shapes " + t + " and " + r + " must match");
  }, r.assertNonNull = function (t) {
    n(null != t, "The input to the tensor constructor must be a non-null value.");
  }, r.flatten = o, r.sizeFromShape = function (t) {
    if (0 === t.length) return 1;

    for (var r = t[0], e = 1; e < t.length; e++) {
      r *= t[e];
    }

    return r;
  }, r.isScalarShape = function (t) {
    return 0 === t.length;
  }, r.arraysEqual = i, r.isInt = function (t) {
    return t % 1 == 0;
  }, r.tanh = function (t) {
    if (null != Math.tanh) return Math.tanh(t);
    if (t === 1 / 0) return 1;
    if (t === -1 / 0) return -1;
    var r = Math.exp(2 * t);
    return (r - 1) / (r + 1);
  }, r.sizeToSquarishShape = function (t) {
    for (var r = Math.floor(Math.sqrt(t)); r > 1; --r) {
      if (t % r == 0) return [r, t / r];
    }

    return [1, t];
  }, r.createShuffledIndices = function (t) {
    for (var r = new Uint32Array(t), n = 0; n < t; ++n) {
      r[n] = n;
    }

    return e(r), r;
  }, r.rightPad = function (t, r) {
    return r <= t.length ? t : t + " ".repeat(r - t.length);
  }, r.repeatedTry = function (t, r, e) {
    return void 0 === r && (r = function r(t) {
      return 0;
    }), new Promise(function (n, o) {
      var i = 0,
          s = function s() {
        if (t()) n();else {
          var a = r(++i);
          null != e && i >= e ? o() : setTimeout(s, a);
        }
      };

      s();
    });
  }, r.inferFromImplicitShape = function (t, r) {
    for (var e = 1, n = -1, o = 0; o < t.length; ++o) {
      if (t[o] >= 0) e *= t[o];else if (-1 === t[o]) {
        if (-1 !== n) throw Error("Shapes can only have 1 implicit size. Found -1 at dim " + n + " and dim " + o);
        n = o;
      } else if (t[o] < 0) throw Error("Shapes can not be < 0. Found " + t[o] + " at dim " + o);
    }

    if (-1 === n) {
      if (r > 0 && r !== e) throw Error("Size(" + r + ") must match the product of shape " + t);
      return t;
    }

    if (0 === e) throw Error("Cannot infer the missing size in [" + t + "] when there are 0 elements");
    if (r % e != 0) throw Error("The implicit shape can't be a fractional number. Got " + r + " / " + e);
    var i = t.slice();
    return i[n] = r / e, i;
  }, r.squeezeShape = function (t, r) {
    for (var e = [], n = [], o = 0, i = 0; i < t.length; ++i) {
      if (null != r) {
        if (r[o] === i && 1 !== t[i]) throw new Error("Can't squeeze axis " + i + " since its dim '" + t[i] + "' is not 1");
        (null == r[o] || r[o] > i) && 1 === t[i] && (e.push(t[i]), n.push(i)), r[o] <= i && o++;
      }

      1 !== t[i] && (e.push(t[i]), n.push(i));
    }

    return {
      newShape: e,
      keptDims: n
    };
  }, r.getTypedArrayFromDType = function (t, r) {
    var e = null;
    if (null == t || "float32" === t) e = new Float32Array(r);else if ("int32" === t) e = new Int32Array(r);else {
      if ("bool" !== t) throw new Error("Unknown data type " + t);
      e = new Uint8Array(r);
    }
    return e;
  }, r.getArrayFromDType = function (t, r) {
    var e = null;
    if (null == t || "float32" === t) e = new Float32Array(r);else if ("int32" === t) e = new Int32Array(r);else if ("bool" === t) e = new Uint8Array(r);else {
      if ("string" !== t) throw new Error("Unknown data type " + t);
      e = new Array(r);
    }
    return e;
  }, r.checkComputationForNaN = function (t, r, e) {
    if ("float32" === r) for (var n = 0; n < t.length; n++) {
      if (isNaN(t[n])) throw Error("The result of the '" + e + "' has NaNs.");
    }
  }, r.checkConversionForNaN = s, r.hasEncodingLoss = function (t, r) {
    return !("complex64" === r || "float32" === r && "complex64" !== t || "int32" === r && "float32" !== t && "complex64" !== t || "bool" === r && "bool" === t);
  }, r.isTypedArray = function (t) {
    return t instanceof Float32Array || t instanceof Int32Array || t instanceof Uint8Array;
  }, r.bytesPerElement = function (t) {
    if ("float32" === t || "int32" === t) return 4;
    if ("complex64" === t) return 8;
    if ("bool" === t) return 1;
    throw new Error("Unknown dtype " + t);
  }, r.bytesFromStringArray = function (t) {
    if (null == t) return 0;
    var r = 0;
    return t.forEach(function (t) {
      return r += 2 * t.length;
    }), r;
  }, r.isString = a, r.isBoolean = u, r.isNumber = h, r.inferDtype = function (t) {
    return t instanceof Float32Array ? "float32" : t instanceof Int32Array || t instanceof Uint8Array ? "int32" : h(t) || t instanceof Array && h(l(t)) ? "float32" : a(t) || t instanceof Array && a(l(t)) ? "string" : u(t) || t instanceof Array && u(l(t)) ? "bool" : "float32";
  }, r.isFunction = function (t) {
    return !!(t && t.constructor && t.call && t.apply);
  }, r.nearestDivisor = function (t, r) {
    for (var e = r; e < t; ++e) {
      if (t % e == 0) return e;
    }

    return t;
  }, r.computeStrides = function (t) {
    var r = t.length;
    if (r < 2) return [];
    var e = new Array(r - 1);
    e[r - 2] = t[r - 1];

    for (var n = r - 3; n >= 0; --n) {
      e[n] = e[n + 1] * t[n + 1];
    }

    return e;
  }, r.toTypedArray = function (t, r, e) {
    if ("string" === r) throw new Error("Cannot convert a string[] to a TypedArray");
    if (function (t, r) {
      return t instanceof Float32Array && "float32" === r || t instanceof Int32Array && "int32" === r || t instanceof Uint8Array && "bool" === r;
    }(t, r)) return t;
    if (Array.isArray(t) && (t = o(t)), null == r || "float32" === r || "complex64" === r) return new Float32Array(t);
    if ("int32" === r) return e && s(t, r), new Int32Array(t);

    if ("bool" === r) {
      for (var n = new Uint8Array(t.length), i = 0; i < n.length; ++i) {
        0 !== Math.round(t[i]) && (n[i] = 1);
      }

      return n;
    }

    throw new Error("Unknown data type " + r);
  }, r.makeOnesTypedArray = function (t, r) {
    for (var e = c(t, r), n = 0; n < e.length; n++) {
      e[n] = 1;
    }

    return e;
  }, r.makeZerosTypedArray = c, r.now = function () {
    if ("undefined" != typeof performance) return performance.now();

    if ("undefined" != typeof process) {
      var t = process.hrtime();
      return 1e3 * t[0] + t[1] / 1e6;
    }

    throw new Error("Cannot measure time in this environment. You should run tf.js in the browser or in Node.js");
  };
});
unwrapExports(util$1);
var util_1 = util$1.shuffle,
    util_2 = util$1.clamp,
    util_3 = util$1.nearestLargerEven,
    util_4 = util$1.sum,
    util_5 = util$1.randUniform,
    util_6 = util$1.distSquared,
    util_7 = util$1.assert,
    util_8 = util$1.assertShapesMatch,
    util_9 = util$1.assertNonNull,
    util_10 = util$1.flatten,
    util_11 = util$1.sizeFromShape,
    util_12 = util$1.isScalarShape,
    util_13 = util$1.arraysEqual,
    util_14 = util$1.isInt,
    util_15 = util$1.tanh,
    util_16 = util$1.sizeToSquarishShape,
    util_17 = util$1.createShuffledIndices,
    util_18 = util$1.rightPad,
    util_19 = util$1.repeatedTry,
    util_20 = util$1.inferFromImplicitShape,
    util_21 = util$1.squeezeShape,
    util_22 = util$1.getTypedArrayFromDType,
    util_23 = util$1.getArrayFromDType,
    util_24 = util$1.checkComputationForNaN,
    util_25 = util$1.checkConversionForNaN,
    util_26 = util$1.hasEncodingLoss,
    util_27 = util$1.isTypedArray,
    util_28 = util$1.bytesPerElement,
    util_29 = util$1.bytesFromStringArray,
    util_30 = util$1.isString,
    util_31 = util$1.isBoolean,
    util_32 = util$1.isNumber,
    util_33 = util$1.inferDtype,
    util_34 = util$1.isFunction,
    util_35 = util$1.nearestDivisor,
    util_36 = util$1.computeStrides,
    util_37 = util$1.toTypedArray,
    util_38 = util$1.makeOnesTypedArray,
    util_39 = util$1.makeZerosTypedArray,
    util_40 = util$1.now,
    tensor_format = createCommonjsModule(function (t, r) {
  Object.defineProperty(r, "__esModule", {
    value: !0
  });
  var e = 20,
      n = 3,
      o = 7;

  function i(t, r) {
    var e;
    return e = Array.isArray(t) ? parseFloat(t[0].toFixed(o)) + " + " + parseFloat(t[1].toFixed(o)) + "j" : util$1.isString(t) ? "'" + t + "'" : parseFloat(t.toFixed(o)).toString(), util$1.rightPad(e, r);
  }

  function s(t) {
    for (var r = [], e = 0; e < t.length; e += 2) {
      r.push([t[e], t[e + 1]]);
    }

    return r;
  }

  r.tensorToString = function (t, r, o, a) {
    var u = util$1.computeStrides(r),
        h = function (t, r, e, n) {
      var o = util$1.sizeFromShape(r),
          a = n[n.length - 1],
          u = new Array(a).fill(0),
          h = r.length,
          c = "complex64" === e ? s(t) : t;
      if (h > 1) for (var l = 0; l < o / a; l++) {
        for (var f = l * a, p = 0; p < a; p++) {
          u[p] = Math.max(u[p], i(c[f + p], 0).length);
        }
      }
      return u;
    }(t, r, o, u),
        c = r.length,
        l = function t(r, o, a, u, h, c) {
      void 0 === c && (c = !0);
      var l = "complex64" === a ? 2 : 1,
          f = o[0],
          p = o.length;

      if (0 === p) {
        if ("complex64" === a) {
          var d = s(r);
          return [i(d[0], 0)];
        }

        return [r[0].toString()];
      }

      if (1 === p) {
        if (f > e) {
          var y = n * l,
              v = Array.from(r.slice(0, y)),
              m = Array.from(r.slice(f - n * l, f));
          return "complex64" === a && (v = s(v), m = s(m)), ["[" + v.map(function (t, r) {
            return i(t, h[r]);
          }).join(", ") + ", ..., " + m.map(function (t, r) {
            return i(t, h[f - n + r]);
          }).join(", ") + "]"];
        }

        var w = "complex64" === a ? s(r) : Array.from(r);
        return ["[" + w.map(function (t, r) {
          return i(t, h[r]);
        }).join(", ") + "]"];
      }

      var _ = o.slice(1),
          g = u.slice(1),
          I = u[0] * l,
          b = [];

      if (f > e) {
        for (var x = 0; x < n; x++) {
          var S = x * I,
              D = S + I;
          b.push.apply(b, t(r.slice(S, D), _, a, g, h, !1));
        }

        b.push("...");

        for (var x = f - n; x < f; x++) {
          var S = x * I,
              D = S + I;
          b.push.apply(b, t(r.slice(S, D), _, a, g, h, x === f - 1));
        }
      } else for (var x = 0; x < f; x++) {
        var S = x * I,
            D = S + I;
        b.push.apply(b, t(r.slice(S, D), _, a, g, h, x === f - 1));
      }

      var T = 2 === p ? "," : "";
      b[0] = "[" + b[0] + T;

      for (var x = 1; x < b.length - 1; x++) {
        b[x] = " " + b[x] + T;
      }

      for (var E = ",\n", x = 2; x < p; x++) {
        E += "\n";
      }

      return b[b.length - 1] = " " + b[b.length - 1] + "]" + (c ? "" : E), b;
    }(t, r, o, u, h),
        f = ["Tensor"];

    return a && (f.push("  dtype: " + o), f.push("  rank: " + c), f.push("  shape: [" + r + "]"), f.push("  values:")), f.push(l.map(function (t) {
      return "    " + t;
    }).join("\n")), f.join("\n");
  };
});
unwrapExports(tensor_format);
var tensor_format_1 = tensor_format.tensorToString,
    tensor = createCommonjsModule(function (t, r) {
  var e,
      n = commonjsGlobal && commonjsGlobal.__extends || (e = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (t, r) {
    t.__proto__ = r;
  } || function (t, r) {
    for (var e in r) {
      r.hasOwnProperty(e) && (t[e] = r[e]);
    }
  }, function (t, r) {
    function n() {
      this.constructor = t;
    }

    e(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
  }),
      o = commonjsGlobal && commonjsGlobal.__awaiter || function (t, r, e, n) {
    return new (e || (e = Promise))(function (o, i) {
      function s(t) {
        try {
          u(n.next(t));
        } catch (t) {
          i(t);
        }
      }

      function a(t) {
        try {
          u(n.throw(t));
        } catch (t) {
          i(t);
        }
      }

      function u(t) {
        t.done ? o(t.value) : new e(function (r) {
          r(t.value);
        }).then(s, a);
      }

      u((n = n.apply(t, r || [])).next());
    });
  },
      i = commonjsGlobal && commonjsGlobal.__generator || function (t, r) {
    var e,
        n,
        o,
        i,
        s = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
    return i = {
      next: a(0),
      throw: a(1),
      return: a(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
      return this;
    }), i;

    function a(i) {
      return function (a) {
        return function (i) {
          if (e) throw new TypeError("Generator is already executing.");

          for (; s;) {
            try {
              if (e = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

              switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                case 0:
                case 1:
                  o = i;
                  break;

                case 4:
                  return s.label++, {
                    value: i[1],
                    done: !1
                  };

                case 5:
                  s.label++, n = i[1], i = [0];
                  continue;

                case 7:
                  i = s.ops.pop(), s.trys.pop();
                  continue;

                default:
                  if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                    s = 0;
                    continue;
                  }

                  if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                    s.label = i[1];
                    break;
                  }

                  if (6 === i[0] && s.label < o[1]) {
                    s.label = o[1], o = i;
                    break;
                  }

                  if (o && s.label < o[2]) {
                    s.label = o[2], s.ops.push(i);
                    break;
                  }

                  o[2] && s.ops.pop(), s.trys.pop();
                  continue;
              }

              i = r.call(t, s);
            } catch (t) {
              i = [6, t], n = 0;
            } finally {
              e = o = 0;
            }
          }

          if (5 & i[0]) throw i[1];
          return {
            value: i[0] ? i[1] : void 0,
            done: !0
          };
        }([i, a]);
      };
    }
  };

  Object.defineProperty(r, "__esModule", {
    value: !0
  });

  var s = util$1,
      a = function () {
    function t(t, r, e) {
      if (this.dtype = r, this.shape = t.slice(), this.size = util$1.sizeFromShape(t), null != e) {
        var n = e.length;
        util$1.assert(n === this.size, "Length of values '" + n + "' does not match the size inferred by the shape '" + this.size + "'.");
      }

      if ("complex64" === r) throw new Error("complex64 dtype TensorBuffers are not supported. Please create a TensorBuffer for the real and imaginary parts separately and call tf.complex(real, imag).");
      this.values = e || util$1.getArrayFromDType(r, util$1.sizeFromShape(this.shape)), this.strides = s.computeStrides(t);
    }

    return t.prototype.set = function (t) {
      for (var r = [], e = 1; e < arguments.length; e++) {
        r[e - 1] = arguments[e];
      }

      0 === r.length && (r = [0]), util$1.assert(r.length === this.rank, "The number of provided coordinates (" + r.length + ") must match the rank (" + this.rank + ")");
      var n = this.locToIndex(r);
      this.values[n] = t;
    }, t.prototype.get = function () {
      for (var t = [], r = 0; r < arguments.length; r++) {
        t[r] = arguments[r];
      }

      0 === t.length && (t = [0]);

      for (var e = t[t.length - 1], n = 0; n < t.length - 1; ++n) {
        e += this.strides[n] * t[n];
      }

      return this.values[e];
    }, t.prototype.locToIndex = function (t) {
      if (0 === this.rank) return 0;
      if (1 === this.rank) return t[0];

      for (var r = t[t.length - 1], e = 0; e < t.length - 1; ++e) {
        r += this.strides[e] * t[e];
      }

      return r;
    }, t.prototype.indexToLoc = function (t) {
      if (0 === this.rank) return [];
      if (1 === this.rank) return [t];

      for (var r = new Array(this.shape.length), e = 0; e < r.length - 1; ++e) {
        r[e] = Math.floor(t / this.strides[e]), t -= r[e] * this.strides[e];
      }

      return r[r.length - 1] = t, r;
    }, Object.defineProperty(t.prototype, "rank", {
      get: function get() {
        return this.shape.length;
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype.toTensor = function () {
      return c.make(this.shape, {
        values: this.values
      }, this.dtype);
    }, t;
  }();

  r.TensorBuffer = a;
  var u = null,
      h = null;
  r.setTensorTracker = function (t) {
    u = t;
  }, r.setOpHandler = function (t) {
    h = t;
  };

  var c = function () {
    function t(t, r, e, n) {
      this.isDisposedInternal = !1, this.shape = t.slice(), this.dtype = r || "float32", this.size = util$1.sizeFromShape(t), null != e && util$1.assert(this.size === e.length, "Based on the provided shape, [" + t + "], and dtype " + this.dtype + ", the tensor should have " + this.size + " values but has " + e.length), this.strides = s.computeStrides(t), this.dataId = null != n ? n : {}, this.id = u().nextTensorId(), this.rankType = this.rank < 5 ? this.rank.toString() : "higher", u().registerTensor(this), null != e && u().write(this.dataId, e);
    }

    return t.make = function (r, e, n) {
      return new t(r, n, e.values, e.dataId);
    }, t.prototype.flatten = function () {
      return this.throwIfDisposed(), this.as1D();
    }, t.prototype.asScalar = function () {
      return this.throwIfDisposed(), util$1.assert(1 === this.size, "The array must have only 1 element."), this.reshape([]);
    }, t.prototype.as1D = function () {
      return this.throwIfDisposed(), this.reshape([this.size]);
    }, t.prototype.as2D = function (t, r) {
      return this.throwIfDisposed(), this.reshape([t, r]);
    }, t.prototype.as3D = function (t, r, e) {
      return this.throwIfDisposed(), this.reshape([t, r, e]);
    }, t.prototype.as4D = function (t, r, e, n) {
      return this.throwIfDisposed(), this.reshape([t, r, e, n]);
    }, t.prototype.asType = function (t) {
      return this.throwIfDisposed(), h.cast(this, t);
    }, Object.defineProperty(t.prototype, "rank", {
      get: function get() {
        return this.shape.length;
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype.get = function () {
      for (var t = [], r = 0; r < arguments.length; r++) {
        t[r] = arguments[r];
      }

      util$1.assert(t.length === this.rank, "Number of coordinates in get() must match the rank of the tensor"), util$1.assert("complex64" !== this.dtype, "Tensor.get() is not supported for complex64 tensors yet."), this.throwIfDisposed(), 0 === t.length && (t = [0]);

      for (var e = t[t.length - 1], n = 0; n < t.length - 1; ++n) {
        e += this.strides[n] * t[n];
      }

      return this.dataSync()[e];
    }, t.prototype.buffer = function () {
      return h.buffer(this.shape, this.dtype, this.dataSync());
    }, t.prototype.data = function () {
      return o(this, void 0, void 0, function () {
        return i(this, function (t) {
          return this.throwIfDisposed(), [2, u().read(this.dataId)];
        });
      });
    }, t.prototype.dataSync = function () {
      return this.throwIfDisposed(), u().readSync(this.dataId);
    }, t.prototype.dispose = function () {
      this.isDisposed || (u().disposeTensor(this), this.isDisposedInternal = !0);
    }, Object.defineProperty(t.prototype, "isDisposed", {
      get: function get() {
        return this.isDisposedInternal;
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype.throwIfDisposed = function () {
      if (this.isDisposed) throw new Error("Tensor is disposed.");
    }, t.prototype.toFloat = function () {
      return this.asType("float32");
    }, t.prototype.toInt = function () {
      return this.asType("int32");
    }, t.prototype.toBool = function () {
      return this.asType("bool");
    }, t.prototype.print = function (t) {
      return void 0 === t && (t = !1), h.print(this, t);
    }, t.prototype.reshape = function (t) {
      return this.throwIfDisposed(), h.reshape(this, t);
    }, t.prototype.reshapeAs = function (t) {
      return this.throwIfDisposed(), this.reshape(t.shape);
    }, t.prototype.expandDims = function (t) {
      return void 0 === t && (t = 0), h.expandDims(this, t);
    }, t.prototype.cumsum = function (t, r, e) {
      return void 0 === t && (t = 0), void 0 === r && (r = !1), void 0 === e && (e = !1), h.cumsum(this, t, r, e);
    }, t.prototype.squeeze = function (t) {
      return this.throwIfDisposed(), h.squeeze(this, t);
    }, t.prototype.clone = function () {
      return this.throwIfDisposed(), h.clone(this);
    }, t.prototype.toString = function (t) {
      void 0 === t && (t = !1);
      var r = this.dataSync();
      return tensor_format.tensorToString(r, this.shape, this.dtype, t);
    }, t.prototype.tile = function (t) {
      return this.throwIfDisposed(), h.tile(this, t);
    }, t.prototype.gather = function (t, r) {
      return void 0 === r && (r = 0), this.throwIfDisposed(), h.gather(this, t, r);
    }, t.prototype.matMul = function (t, r, e) {
      return void 0 === r && (r = !1), void 0 === e && (e = !1), this.throwIfDisposed(), h.matMul(this, t, r, e);
    }, t.prototype.dot = function (t) {
      return this.throwIfDisposed(), h.dot(this, t);
    }, t.prototype.norm = function (t, r, e) {
      return void 0 === t && (t = "euclidean"), void 0 === r && (r = null), void 0 === e && (e = !1), this.throwIfDisposed(), h.norm(this, t, r, e);
    }, t.prototype.slice = function (t, r) {
      return this.throwIfDisposed(), h.slice(this, t, r);
    }, t.prototype.reverse = function (t) {
      return this.throwIfDisposed(), h.reverse(this, t);
    }, t.prototype.concat = function (r, e) {
      return void 0 === e && (e = 0), this.throwIfDisposed(), r instanceof t && (r = [r]), h.concat([this].concat(r), e);
    }, t.prototype.split = function (t, r) {
      return void 0 === r && (r = 0), this.throwIfDisposed(), h.split(this, t, r);
    }, t.prototype.stack = function (t, r) {
      return void 0 === r && (r = 0), h.stack([this, t], r);
    }, t.prototype.unstack = function (t, r) {
      return void 0 === r && (r = 0), h.unstack(this, r);
    }, t.prototype.pad = function (t, r) {
      return void 0 === r && (r = 0), h.pad(this, t, r);
    }, t.prototype.batchNormalization = function (t, r, e, n, o) {
      return void 0 === e && (e = .001), this.throwIfDisposed(), h.batchNormalization(this, t, r, e, n, o);
    }, t.prototype.all = function (t, r) {
      return void 0 === t && (t = null), void 0 === r && (r = !1), this.throwIfDisposed(), h.all(this, t, r);
    }, t.prototype.any = function (t, r) {
      return void 0 === t && (t = null), void 0 === r && (r = !1), this.throwIfDisposed(), h.any(this, t, r);
    }, t.prototype.logSumExp = function (t, r) {
      return void 0 === t && (t = null), void 0 === r && (r = !1), this.throwIfDisposed(), h.logSumExp(this, t, r);
    }, t.prototype.sum = function (t, r) {
      return void 0 === t && (t = null), void 0 === r && (r = !1), this.throwIfDisposed(), h.sum(this, t, r);
    }, t.prototype.prod = function (t, r) {
      return void 0 === t && (t = null), void 0 === r && (r = !1), this.throwIfDisposed(), h.prod(this, t, r);
    }, t.prototype.mean = function (t, r) {
      return void 0 === t && (t = null), void 0 === r && (r = !1), this.throwIfDisposed(), h.mean(this, t, r);
    }, t.prototype.min = function (t, r) {
      return void 0 === t && (t = null), void 0 === r && (r = !1), this.throwIfDisposed(), h.min(this, t, r);
    }, t.prototype.max = function (t, r) {
      return void 0 === t && (t = null), void 0 === r && (r = !1), this.throwIfDisposed(), h.max(this, t, r);
    }, t.prototype.argMin = function (t) {
      return void 0 === t && (t = null), this.throwIfDisposed(), h.argMin(this, t);
    }, t.prototype.argMax = function (t) {
      return void 0 === t && (t = null), this.throwIfDisposed(), h.argMax(this, t);
    }, t.prototype.cast = function (t) {
      return this.throwIfDisposed(), h.cast(this, t);
    }, t.prototype.add = function (t) {
      return this.throwIfDisposed(), h.add(this, t);
    }, t.prototype.addStrict = function (t) {
      return this.throwIfDisposed(), h.addStrict(this, t);
    }, t.prototype.atan2 = function (t) {
      return this.throwIfDisposed(), h.atan2(this, t);
    }, t.prototype.sub = function (t) {
      return this.throwIfDisposed(), h.sub(this, t);
    }, t.prototype.subStrict = function (t) {
      return this.throwIfDisposed(), h.subStrict(this, t);
    }, t.prototype.pow = function (t) {
      return this.throwIfDisposed(), h.pow(this, t);
    }, t.prototype.powStrict = function (t) {
      return this.throwIfDisposed(), h.powStrict(this, t);
    }, t.prototype.mul = function (t) {
      return this.throwIfDisposed(), h.mul(this, t);
    }, t.prototype.mulStrict = function (t) {
      return this.throwIfDisposed(), h.mulStrict(this, t);
    }, t.prototype.div = function (t) {
      return this.throwIfDisposed(), h.div(this, t);
    }, t.prototype.floorDiv = function (t) {
      return this.throwIfDisposed(), h.floorDiv(this, t);
    }, t.prototype.divStrict = function (t) {
      return this.throwIfDisposed(), h.divStrict(this, t);
    }, t.prototype.minimum = function (t) {
      return this.throwIfDisposed(), h.minimum(this, t);
    }, t.prototype.minimumStrict = function (t) {
      return this.throwIfDisposed(), h.minimumStrict(this, t);
    }, t.prototype.maximum = function (t) {
      return this.throwIfDisposed(), h.maximum(this, t);
    }, t.prototype.maximumStrict = function (t) {
      return this.throwIfDisposed(), h.maximumStrict(this, t);
    }, t.prototype.mod = function (t) {
      return this.throwIfDisposed(), h.mod(this, t);
    }, t.prototype.modStrict = function (t) {
      return this.throwIfDisposed(), h.modStrict(this, t);
    }, t.prototype.squaredDifference = function (t) {
      return this.throwIfDisposed(), h.squaredDifference(this, t);
    }, t.prototype.squaredDifferenceStrict = function (t) {
      return this.throwIfDisposed(), h.squaredDifferenceStrict(this, t);
    }, t.prototype.transpose = function (t) {
      return this.throwIfDisposed(), h.transpose(this, t);
    }, t.prototype.notEqual = function (t) {
      return this.throwIfDisposed(), h.notEqual(this, t);
    }, t.prototype.notEqualStrict = function (t) {
      return this.throwIfDisposed(), h.notEqualStrict(this, t);
    }, t.prototype.less = function (t) {
      return this.throwIfDisposed(), h.less(this, t);
    }, t.prototype.lessStrict = function (t) {
      return this.throwIfDisposed(), h.lessStrict(this, t);
    }, t.prototype.equal = function (t) {
      return this.throwIfDisposed(), h.equal(this, t);
    }, t.prototype.equalStrict = function (t) {
      return this.throwIfDisposed(), h.equalStrict(this, t);
    }, t.prototype.lessEqual = function (t) {
      return this.throwIfDisposed(), h.lessEqual(this, t);
    }, t.prototype.lessEqualStrict = function (t) {
      return this.throwIfDisposed(), h.lessEqualStrict(this, t);
    }, t.prototype.greater = function (t) {
      return this.throwIfDisposed(), h.greater(this, t);
    }, t.prototype.greaterStrict = function (t) {
      return this.throwIfDisposed(), h.greaterStrict(this, t);
    }, t.prototype.greaterEqual = function (t) {
      return this.throwIfDisposed(), h.greaterEqual(this, t);
    }, t.prototype.greaterEqualStrict = function (t) {
      return this.throwIfDisposed(), h.greaterEqualStrict(this, t);
    }, t.prototype.logicalAnd = function (t) {
      return this.throwIfDisposed(), h.logicalAnd(this, t);
    }, t.prototype.logicalOr = function (t) {
      return this.throwIfDisposed(), h.logicalOr(this, t);
    }, t.prototype.logicalNot = function () {
      return this.throwIfDisposed(), h.logicalNot(this);
    }, t.prototype.logicalXor = function (t) {
      return this.throwIfDisposed(), h.logicalXor(this, t);
    }, t.prototype.where = function (t, r) {
      return this.throwIfDisposed(), h.where(t, this, r);
    }, t.prototype.neg = function () {
      return this.throwIfDisposed(), h.neg(this);
    }, t.prototype.ceil = function () {
      return this.throwIfDisposed(), h.ceil(this);
    }, t.prototype.floor = function () {
      return this.throwIfDisposed(), h.floor(this);
    }, t.prototype.sign = function () {
      return this.throwIfDisposed(), h.sign(this);
    }, t.prototype.exp = function () {
      return this.throwIfDisposed(), h.exp(this);
    }, t.prototype.expm1 = function () {
      return this.throwIfDisposed(), h.expm1(this);
    }, t.prototype.log = function () {
      return this.throwIfDisposed(), h.log(this);
    }, t.prototype.log1p = function () {
      return this.throwIfDisposed(), h.log1p(this);
    }, t.prototype.sqrt = function () {
      return this.throwIfDisposed(), h.sqrt(this);
    }, t.prototype.rsqrt = function () {
      return this.throwIfDisposed(), h.rsqrt(this);
    }, t.prototype.square = function () {
      return this.throwIfDisposed(), h.square(this);
    }, t.prototype.reciprocal = function () {
      return this.throwIfDisposed(), h.reciprocal(this);
    }, t.prototype.abs = function () {
      return this.throwIfDisposed(), h.abs(this);
    }, t.prototype.clipByValue = function (t, r) {
      return this.throwIfDisposed(), h.clipByValue(this, t, r);
    }, t.prototype.relu = function () {
      return this.throwIfDisposed(), h.relu(this);
    }, t.prototype.elu = function () {
      return this.throwIfDisposed(), h.elu(this);
    }, t.prototype.selu = function () {
      return this.throwIfDisposed(), h.selu(this);
    }, t.prototype.leakyRelu = function (t) {
      return void 0 === t && (t = .2), this.throwIfDisposed(), h.leakyRelu(this, t);
    }, t.prototype.prelu = function (t) {
      return this.throwIfDisposed(), h.prelu(this, t);
    }, t.prototype.sigmoid = function () {
      return this.throwIfDisposed(), h.sigmoid(this);
    }, t.prototype.logSigmoid = function () {
      return this.throwIfDisposed(), h.logSigmoid(this);
    }, t.prototype.softplus = function () {
      return this.throwIfDisposed(), h.softplus(this);
    }, t.prototype.zerosLike = function () {
      return this.throwIfDisposed(), h.zerosLike(this);
    }, t.prototype.onesLike = function () {
      return this.throwIfDisposed(), h.onesLike(this);
    }, t.prototype.sin = function () {
      return this.throwIfDisposed(), h.sin(this);
    }, t.prototype.cos = function () {
      return this.throwIfDisposed(), h.cos(this);
    }, t.prototype.tan = function () {
      return this.throwIfDisposed(), h.tan(this);
    }, t.prototype.asin = function () {
      return this.throwIfDisposed(), h.asin(this);
    }, t.prototype.acos = function () {
      return this.throwIfDisposed(), h.acos(this);
    }, t.prototype.atan = function () {
      return this.throwIfDisposed(), h.atan(this);
    }, t.prototype.sinh = function () {
      return this.throwIfDisposed(), h.sinh(this);
    }, t.prototype.cosh = function () {
      return this.throwIfDisposed(), h.cosh(this);
    }, t.prototype.tanh = function () {
      return this.throwIfDisposed(), h.tanh(this);
    }, t.prototype.asinh = function () {
      return this.throwIfDisposed(), h.asinh(this);
    }, t.prototype.acosh = function () {
      return this.throwIfDisposed(), h.acosh(this);
    }, t.prototype.atanh = function () {
      return this.throwIfDisposed(), h.atanh(this);
    }, t.prototype.erf = function () {
      return this.throwIfDisposed(), h.erf(this);
    }, t.prototype.round = function () {
      return this.throwIfDisposed(), h.round(this);
    }, t.prototype.step = function (t) {
      return void 0 === t && (t = 0), this.throwIfDisposed(), h.step(this, t);
    }, t.prototype.softmax = function (t) {
      return void 0 === t && (t = -1), this.throwIfDisposed(), h.softmax(this, t);
    }, t.prototype.logSoftmax = function (t) {
      return void 0 === t && (t = -1), this.throwIfDisposed(), h.logSoftmax(this, t);
    }, t.prototype.resizeBilinear = function (t, r) {
      return void 0 === r && (r = !1), this.throwIfDisposed(), h.image.resizeBilinear(this, t, r);
    }, t.prototype.resizeNearestNeighbor = function (t, r) {
      return void 0 === r && (r = !1), this.throwIfDisposed(), h.image.resizeNearestNeighbor(this, t, r);
    }, t.prototype.conv1d = function (t, r, e, n, o, i) {
      return void 0 === n && (n = "NWC"), void 0 === o && (o = 1), this.throwIfDisposed(), h.conv1d(this, t, r, e, n, o, i);
    }, t.prototype.conv2d = function (t, r, e, n, o, i) {
      return void 0 === n && (n = "NHWC"), void 0 === o && (o = [1, 1]), this.throwIfDisposed(), h.conv2d(this, t, r, e, n, o, i);
    }, t.prototype.conv2dTranspose = function (t, r, e, n, o) {
      return this.throwIfDisposed(), h.conv2dTranspose(this, t, r, e, n, o);
    }, t.prototype.depthwiseConv2D = function (t, r, e, n, o, i) {
      return void 0 === n && (n = "NHWC"), void 0 === o && (o = [1, 1]), this.throwIfDisposed(), h.depthwiseConv2d(this, t, r, e, n, o, i);
    }, t.prototype.separableConv2d = function (t, r, e, n, o, i) {
      return void 0 === o && (o = [1, 1]), void 0 === i && (i = "NHWC"), this.throwIfDisposed(), h.separableConv2d(this, t, r, e, n, o, i);
    }, t.prototype.avgPool = function (t, r, e, n) {
      return this.throwIfDisposed(), h.avgPool(this, t, r, e, n);
    }, t.prototype.maxPool = function (t, r, e, n) {
      return this.throwIfDisposed(), h.maxPool(this, t, r, e, n);
    }, t.prototype.localResponseNormalization = function (t, r, e, n) {
      return void 0 === t && (t = 5), void 0 === r && (r = 1), void 0 === e && (e = 1), void 0 === n && (n = .5), h.localResponseNormalization(this, t, r, e, n);
    }, t.prototype.pool = function (t, r, e, n, o) {
      return this.throwIfDisposed(), h.pool(this, t, r, e, n, o);
    }, t.prototype.variable = function (t, r, e) {
      return void 0 === t && (t = !0), this.throwIfDisposed(), l.variable(this, t, r, e);
    }, t.prototype.unsortedSegmentSum = function (t, r) {
      return this.throwIfDisposed(), h.unsortedSegmentSum(this, t, r);
    }, t.prototype.batchToSpaceND = function (t, r) {
      return this.throwIfDisposed(), h.batchToSpaceND(this, t, r);
    }, t.prototype.spaceToBatchND = function (t, r) {
      return this.throwIfDisposed(), h.spaceToBatchND(this, t, r);
    }, t.prototype.topk = function (t, r) {
      return void 0 === t && (t = 1), void 0 === r && (r = !0), this.throwIfDisposed(), h.topk(this, t, r);
    }, t.prototype.stridedSlice = function (t, r, e, n, o) {
      return void 0 === n && (n = 0), void 0 === o && (o = 0), this.throwIfDisposed(), h.stridedSlice(this, t, r, e, n, o);
    }, t.prototype.depthToSpace = function (t, r) {
      return this.throwIfDisposed(), h.depthToSpace(this, t, r);
    }, t.prototype.fft = function () {
      return this.throwIfDisposed(), h.spectral.fft(this);
    }, t.prototype.ifft = function () {
      return this.throwIfDisposed(), h.spectral.ifft(this);
    }, t;
  }();

  r.Tensor = c, Object.defineProperty(c, Symbol.hasInstance, {
    value: function value(t) {
      return !!t && null != t.shape && null != t.dtype;
    }
  });

  var l = function (t) {
    function r(r, e, n) {
      void 0 === e && (e = !0);
      var o = t.call(this, r.shape, r.dtype, null, r.dataId) || this;
      o.trainable = e, o.name = n, null == o.name && (o.name = u().nextVariableId().toString());

      try {
        u().registerVariable(o);
      } catch (t) {
        throw u().disposeTensor(o), t;
      }

      return o;
    }

    return n(r, t), r.variable = function (t, e, n, o) {
      return void 0 === e && (e = !0), null != o && o !== t.dtype && (t = t.asType(o)), new r(t, e, n);
    }, r.prototype.assign = function (t) {
      if (t.dtype !== this.dtype) throw new Error("dtype of the new value (" + t.dtype + ") and previous value (" + this.dtype + ") must match");
      if (!util$1.arraysEqual(t.shape, this.shape)) throw new Error("shape of the new value (" + t.shape + ") and previous value (" + this.shape + ") must match");
      u().disposeTensor(this), this.dataId = t.dataId, u().registerTensor(this);
    }, r;
  }(c);

  r.Variable = l, Object.defineProperty(l, Symbol.hasInstance, {
    value: function value(t) {
      return t instanceof c && null != t.assign && t.assign instanceof Function;
    }
  });
  var f = l.variable;
  r.variable = f;
});
unwrapExports(tensor);
var tensor_1 = tensor.TensorBuffer,
    tensor_2 = tensor.setTensorTracker,
    tensor_3 = tensor.setOpHandler,
    tensor_4 = tensor.Tensor,
    tensor_5 = tensor.Variable,
    tensor_6 = tensor.variable,
    tensor_util = createCommonjsModule(function (t, r) {
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.assertTypesMatch = function (t, r) {
    util$1.assert(t.dtype === r.dtype, "The dtypes of the first(" + t.dtype + ") and second(" + r.dtype + ") input must match");
  }, r.isTensorInList = function (t, r) {
    for (var e = 0; e < r.length; e++) {
      if (r[e].id === t.id) return !0;
    }

    return !1;
  }, r.flattenNameArrayMap = function (t, r) {
    var e = [];
    if (t instanceof tensor.Tensor) e.push(t);else for (var n = t, o = 0; o < r.length; o++) {
      e.push(n[r[o]]);
    }
    return e;
  }, r.unflattenToNameArrayMap = function (t, r) {
    if (t.length !== r.length) throw new Error("Cannot unflatten Tensor[], keys and arrays are not of same length.");

    for (var e = {}, n = 0; n < t.length; n++) {
      e[t[n]] = r[n];
    }

    return e;
  }, r.getTensorsInContainer = function (t) {
    var r = [];
    return function t(r, e, n) {
      if (null != r) if (r instanceof tensor.Tensor) e.push(r);else if (o = r, Array.isArray(o) || "object" == typeof o) {
        var o,
            i = r;

        for (var s in i) {
          var a = i[s];
          n.has(a) || (n.add(a), t(a, e, n));
        }
      }
    }(t, r, new Set()), r;
  };
});
unwrapExports(tensor_util);
var tensor_util_1 = tensor_util.assertTypesMatch,
    tensor_util_2 = tensor_util.isTensorInList,
    tensor_util_3 = tensor_util.flattenNameArrayMap,
    tensor_util_4 = tensor_util.unflattenToNameArrayMap,
    tensor_util_5 = tensor_util.getTensorsInContainer;

function deepMapInternal(t, r, e, n) {
  if (void 0 === e && (e = new Map()), void 0 === n && (n = new Set()), null == t) return null;
  if (n.has(t)) throw new Error("Circular references are not supported.");
  if (e.has(t)) return e.get(t);
  var o = r(t);
  if (o.recurse && null !== o.value) throw new Error("A deep map function may not return both a value and recurse=true.");

  if (o.recurse) {
    if (isIterable(t)) {
      var i = Array.isArray(t) ? [] : {};

      for (var s in n.add(t), t) {
        var a = deepMapInternal(t[s], r, e, n);
        i[s] = a;
      }

      return n.delete(t), i;
    }

    throw new Error("Can't recurse into non-iterable type: " + t);
  }

  return e.set(t, o.value), o.value;
}

function deepZip(t, r) {
  return void 0 === r && (r = zipToList), deepZipInternal(t, r);
}

function deepZipInternal(t, r, e) {
  void 0 === e && (e = new Set());
  var n = t[0];
  if (e.has(n)) throw new Error("Circular references are not supported.");
  var o = r(t);
  if (o.recurse && null !== o.value) throw new Error("A deep zip function may not return both a value and recurse=true.");

  if (o.recurse) {
    if (isIterable(n)) {
      var i = Array.isArray(n) ? [] : {};
      e.add(n);

      var s = function s(n) {
        var o = deepZipInternal(t.map(function (t) {
          return t[n];
        }), r, e);
        i[n] = o;
      };

      for (var a in n) {
        s(a);
      }

      return e.delete(n), i;
    }

    throw new Error("Can't recurse into non-iterable type: " + n);
  }

  return o.value;
}

function zipToList(t) {
  return null === t ? null : isIterable(t[0]) ? {
    value: null,
    recurse: !0
  } : {
    value: t,
    recurse: !1
  };
}

function deepMapAndAwaitAll(t, r) {
  return __awaiter(this, void 0, void 0, function () {
    var e, n, o, i, s, a;
    return __generator(this, function (u) {
      switch (u.label) {
        case 0:
          e = new Map(), deepMapInternal(t, r, e), n = 0, o = Array.from(e.keys()), u.label = 1;

        case 1:
          return n < o.length ? (i = o[n], (s = e.get(i)) instanceof Promise ? [4, s] : [3, 3]) : [3, 4];

        case 2:
          a = u.sent(), e.set(i, a), u.label = 3;

        case 3:
          return n++, [3, 1];

        case 4:
          return [2, deepMapInternal(t, r, e)];
      }
    });
  });
}

function isIterable(t) {
  return null != t && (Array.isArray(t) || "object" == typeof t && !(t instanceof Tensor));
}

function isNumericArray(t) {
  if (null == t) return !1;
  if (!Array.isArray(t)) return !1;

  for (var r in t) {
    if ("number" != typeof t[r]) return !1;
  }

  return !0;
}

var RingBuffer = function () {
  function t(t) {
    if (this.capacity = t, this.begin = 0, this.end = 0, t < 1) throw new RangeError("Can't create ring buffer of capacity < 1.");
    this.data = new Array(t), this.doubledCapacity = 2 * t;
  }

  return t.prototype.wrap = function (t) {
    for (; t < 0;) {
      t += this.doubledCapacity;
    }

    return t % this.doubledCapacity;
  }, t.prototype.get = function (t) {
    if (t < 0) throw new RangeError("Can't get item at a negative index.");
    return this.data[t % this.capacity];
  }, t.prototype.set = function (t, r) {
    if (t < 0) throw new RangeError("Can't set item at a negative index.");
    this.data[t % this.capacity] = r;
  }, t.prototype.length = function () {
    var t = this.end - this.begin;
    return t < 0 && (t = this.doubledCapacity + t), t;
  }, t.prototype.isFull = function () {
    return this.length() === this.capacity;
  }, t.prototype.isEmpty = function () {
    return 0 === this.length();
  }, t.prototype.push = function (t) {
    if (this.isFull()) throw new RangeError("Ring buffer is full.");
    this.set(this.end, t), this.end = this.wrap(this.end + 1);
  }, t.prototype.pushAll = function (t) {
    for (var r = 0, e = t; r < e.length; r++) {
      var n = e[r];
      this.push(n);
    }
  }, t.prototype.pop = function () {
    if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
    this.end = this.wrap(this.end - 1);
    var t = this.get(this.end);
    return this.set(this.end, void 0), t;
  }, t.prototype.unshift = function (t) {
    if (this.isFull()) throw new RangeError("Ring buffer is full.");
    this.begin = this.wrap(this.begin - 1), this.set(this.begin, t);
  }, t.prototype.shift = function () {
    if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
    var t = this.get(this.begin);
    return this.set(this.begin, void 0), this.begin = this.wrap(this.begin + 1), t;
  }, t.prototype.shuffleExcise = function (t) {
    if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
    var r = this.wrap(this.begin + t),
        e = this.get(r);
    return this.set(r, this.pop()), e;
  }, t;
}(),
    GrowingRingBuffer = function (t) {
  function r() {
    return t.call(this, r.INITIAL_CAPACITY) || this;
  }

  return __extends(r, t), r.prototype.isFull = function () {
    return !1;
  }, r.prototype.push = function (r) {
    t.prototype.isFull.call(this) && this.expand(), t.prototype.push.call(this, r);
  }, r.prototype.unshift = function (r) {
    t.prototype.isFull.call(this) && this.expand(), t.prototype.unshift.call(this, r);
  }, r.prototype.expand = function () {
    for (var t = 2 * this.capacity, r = new Array(t), e = this.length(), n = 0; n < e; n++) {
      r[n] = this.get(this.wrap(this.begin + n));
    }

    this.data = r, this.capacity = t, this.doubledCapacity = 2 * this.capacity, this.begin = 0, this.end = e;
  }, r.INITIAL_CAPACITY = 32, r;
}(RingBuffer);

function iteratorFromItems(t) {
  return new ArrayIterator(t);
}

function iteratorFromFunction(t) {
  return new FunctionCallIterator(t);
}

function iteratorFromConcatenated(t, r) {
  return new ChainedIterator(t, r);
}

function iteratorFromZipped(t, r) {
  return void 0 === r && (r = ZipMismatchMode.FAIL), new ZipIterator(t, r);
}

var ZipMismatchMode,
    LazyIterator = function () {
  function t() {}

  return t.prototype.collect = function (t, r) {
    return void 0 === t && (t = 1e3), void 0 === r && (r = 100), __awaiter(this, void 0, void 0, function () {
      var e, n, o, i;
      return __generator(this, function (s) {
        switch (s.label) {
          case 0:
            return e = r > 0 ? this.prefetch(r) : this, n = [], o = 0, [4, e.next()];

          case 1:
            i = s.sent(), s.label = 2;

          case 2:
            return i.done ? [3, 4] : (n.push(i.value), ++o >= t ? [2, n] : [4, e.next()]);

          case 3:
            return i = s.sent(), [3, 2];

          case 4:
            return [2, n];
        }
      });
    });
  }, t.prototype.resolveFully = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            return [4, this.next()];

          case 1:
            t = r.sent(), r.label = 2;

          case 2:
            return t.done ? [3, 4] : [4, this.next()];

          case 3:
            return t = r.sent(), [3, 2];

          case 4:
            return [2];
        }
      });
    });
  }, t.prototype.resolveWhile = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      var r, e;
      return __generator(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, this.next()];

          case 1:
            r = n.sent(), e = t(r.value), n.label = 2;

          case 2:
            return r.done || !e ? [3, 4] : [4, this.next()];

          case 3:
            return r = n.sent(), e = t(r.value), [3, 2];

          case 4:
            return [2];
        }
      });
    });
  }, t.prototype.handleErrors = function (t) {
    return new ErrorHandlingLazyIterator(this, t);
  }, t.prototype.filter = function (t) {
    return new FilterIterator(this, t);
  }, t.prototype.map = function (t) {
    return new MapIterator(this, t);
  }, t.prototype.mapAsync = function (t) {
    return new AsyncMapIterator(this, t);
  }, t.prototype.serialMapAsync = function (t) {
    return new AsyncMapIterator(this, t).serial();
  }, t.prototype.flatmap = function (t) {
    return new FlatmapIterator(this, t);
  }, t.prototype.forEach = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (r) {
        return [2, this.map(t).resolveFully()];
      });
    });
  }, t.prototype.serialForEach = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (r) {
        return [2, this.serialMapAsync(t).resolveWhile(function (t) {
          return !0 === t;
        })];
      });
    });
  }, t.prototype.rowMajorBatch = function (t, r) {
    return void 0 === r && (r = !0), new RowMajorBatchIterator(this, t, r);
  }, t.prototype.columnMajorBatch = function (t, r, e) {
    return void 0 === r && (r = !0), void 0 === e && (e = zipToList), this.rowMajorBatch(t, r).map(function (t) {
      return deepZip(t, e);
    });
  }, t.prototype.concatenate = function (t, r) {
    return new ChainedIterator(iteratorFromItems([this, t]), r);
  }, t.prototype.take = function (t) {
    return t < 0 || null == t ? this : new TakeIterator(this, t);
  }, t.prototype.skip = function (t) {
    return t < 0 || null == t ? this : new SkipIterator(this, t);
  }, t.prototype.prefetch = function (t) {
    return new PrefetchIterator(this, t);
  }, t.prototype.shuffle = function (t, r) {
    return new ShuffleIterator(this, t, r);
  }, t.prototype.serial = function () {
    return new SerialIterator(this);
  }, t;
}(),
    ArrayIterator = function (t) {
  function r(r) {
    var e = t.call(this) || this;
    return e.items = r, e.trav = 0, e;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return "Array of " + this.items.length + " items";
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (r) {
        return this.trav >= this.items.length ? [2, {
          value: null,
          done: !0
        }] : (t = this.items[this.trav], this.trav++, [2, {
          value: t,
          done: !1
        }]);
      });
    });
  }, r;
}(LazyIterator),
    FunctionCallIterator = function (t) {
  function r(r) {
    var e = t.call(this) || this;
    return e.nextFn = r, e;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return "Function call";
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        try {
          return [2, this.nextFn()];
        } catch (t) {
          throw t.message = "Error thrown while iterating through a dataset: " + t.message, t;
        }

        return [2];
      });
    });
  }, r;
}(LazyIterator),
    SerialIterator = function (t) {
  function r(r) {
    var e = t.call(this) || this;
    return e.upstream = r, e.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), e;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> Serial";
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (r) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, r.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, this.upstream.next()];
      });
    });
  }, r;
}(LazyIterator),
    SkipIterator = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.upstream = r, n.maxCount = e, n.count = 0, n.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> Skip";
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (r) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, r.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            return this.count++ < this.maxCount ? [4, this.upstream.next()] : [3, 2];

          case 1:
            return (t = r.sent()).done ? [2, t] : (dispose(t.value), [3, 0]);

          case 2:
            return [2, this.upstream.next()];
        }
      });
    });
  }, r;
}(LazyIterator),
    TakeIterator = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.upstream = r, n.maxCount = e, n.count = 0, n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> Take";
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return this.count++ >= this.maxCount ? [2, {
          value: null,
          done: !0
        }] : [2, this.upstream.next()];
      });
    });
  }, r;
}(LazyIterator),
    RowMajorBatchIterator = function (t) {
  function r(r, e, n) {
    void 0 === n && (n = !0);
    var o = t.call(this) || this;
    return o.upstream = r, o.batchSize = e, o.enableSmallLastBatch = n, o.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), o;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> RowMajorBatch";
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (r) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, r.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, r;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            t = [], e.label = 1;

          case 1:
            return t.length < this.batchSize ? [4, this.upstream.next()] : [3, 3];

          case 2:
            return (r = e.sent()).done ? this.enableSmallLastBatch && t.length > 0 ? [2, {
              value: t,
              done: !1
            }] : [2, {
              value: null,
              done: !0
            }] : (t.push(r.value), [3, 1]);

          case 3:
            return [2, {
              value: t,
              done: !1
            }];
        }
      });
    });
  }, r;
}(LazyIterator),
    FilterIterator = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.upstream = r, n.predicate = e, n.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> Filter";
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (r) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, r.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            return (t = r.sent()).done || this.predicate(t.value) ? [2, t] : (dispose(t.value), [3, 0]);

          case 2:
            return [2];
        }
      });
    });
  }, r;
}(LazyIterator),
    MapIterator = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.upstream = r, n.transform = e, n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> Map";
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, r, e, n, o, i, s;
      return __generator(this, function (a) {
        switch (a.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            if ((t = a.sent()).done) return [2, {
              value: null,
              done: !0
            }];

            for (r = tensor_util_5(t.value), e = this.transform(t.value), n = tensor_util_5(e), o = 0, i = r; o < i.length; o++) {
              s = i[o], tensor_util_2(s, n) || s.dispose();
            }

            return [2, {
              value: e,
              done: !1
            }];
        }
      });
    });
  }, r;
}(LazyIterator),
    ErrorHandlingLazyIterator = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.upstream = r, n.handler = e, n.count = 0, n.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> handleErrors";
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (r) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, r.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            r.label = 1;

          case 1:
            return r.trys.push([1, 3,, 4]), [4, this.upstream.next()];

          case 2:
            return [2, r.sent()];

          case 3:
            return t = r.sent(), this.handler(t) ? [3, 4] : [2, {
              value: null,
              done: !0
            }];

          case 4:
            return [3, 0];

          case 5:
            return [2];
        }
      });
    });
  }, r;
}(LazyIterator),
    AsyncMapIterator = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.upstream = r, n.transform = e, n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> AsyncMap";
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, r, e, n, o, i, s;
      return __generator(this, function (a) {
        switch (a.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            return (t = a.sent()).done ? [2, {
              value: null,
              done: !0
            }] : (r = tensor_util_5(t.value), [4, this.transform(t.value)]);

          case 2:
            for (e = a.sent(), n = tensor_util_5(e), o = 0, i = r; o < i.length; o++) {
              s = i[o], tensor_util_2(s, n) || s.dispose();
            }

            return [2, {
              value: e,
              done: !1
            }];
        }
      });
    });
  }, r;
}(LazyIterator),
    OneToManyIterator = function (t) {
  function r() {
    var r = t.call(this) || this;
    return r.outputQueue = new GrowingRingBuffer(), r.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), r;
  }

  return __extends(r, t), r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (r) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, r.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return 0 !== this.outputQueue.length() ? [3, 2] : [4, this.pump()];

          case 1:
            return t.sent() ? [3, 0] : [2, {
              value: null,
              done: !0
            }];

          case 2:
            return [2, {
              value: this.outputQueue.shift(),
              done: !1
            }];
        }
      });
    });
  }, r;
}(LazyIterator),
    FlatmapIterator = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.upstream = r, n.transform = e, n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> Flatmap";
  }, r.prototype.pump = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, r, e, n, o, i, s;
      return __generator(this, function (a) {
        switch (a.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            if ((t = a.sent()).done) return [2, !1];

            for (r = tensor_util_5(t.value), e = this.transform(t.value), n = tensor_util_5(e), this.outputQueue.pushAll(e), o = 0, i = r; o < i.length; o++) {
              s = i[o], tensor_util_2(s, n) || s.dispose();
            }

            return [2, !0];
        }
      });
    });
  }, r;
}(OneToManyIterator),
    ChainedIterator = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.baseErrorHandler = e, n.lastRead = null, n.iterator = null, n.moreIterators = r, n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return "TODO: fill in upstream of chained summaries -> Chained";
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return this.lastRead = this.readFromChain(this.lastRead), [2, this.lastRead];
      });
    });
  }, r.prototype.readFromChain = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      var r, e;
      return __generator(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, t];

          case 1:
            return n.sent(), null != this.iterator ? [3, 3] : [4, this.moreIterators.next()];

          case 2:
            if ((r = n.sent()).done) return [2, {
              value: null,
              done: !0
            }];
            this.iterator = r.value, null != this.baseErrorHandler && (this.iterator = this.iterator.handleErrors(this.baseErrorHandler)), n.label = 3;

          case 3:
            return [4, this.iterator.next()];

          case 4:
            return (e = n.sent()).done ? (this.iterator = null, [2, this.readFromChain(t)]) : [2, e];
        }
      });
    });
  }, r;
}(LazyIterator);

!function (t) {
  t[t.FAIL = 0] = "FAIL", t[t.SHORTEST = 1] = "SHORTEST", t[t.LONGEST = 2] = "LONGEST";
}(ZipMismatchMode || (ZipMismatchMode = {}));

var ZipIterator = function (t) {
  function r(r, e) {
    void 0 === e && (e = ZipMismatchMode.FAIL);
    var n = t.call(this) || this;
    return n.iterators = r, n.mismatchMode = e, n.count = 0, n.currentPromise = null, n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return "{TODO: fill in upstream of zip summaries} -> Zip";
  }, r.prototype.nextState = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      function r(t) {
        return t instanceof LazyIterator ? {
          value: t.next().then(function (t) {
            return e++, t.done && n++, t.value;
          }),
          recurse: !1
        } : {
          value: null,
          recurse: !0
        };
      }

      var e, n, o;
      return __generator(this, function (i) {
        switch (i.label) {
          case 0:
            return [4, t];

          case 1:
            return i.sent(), e = 0, n = 0, [4, deepMapAndAwaitAll(this.iterators, r)];

          case 2:
            if (o = i.sent(), e === n) return [2, {
              value: null,
              done: !0
            }];
            if (n > 0) switch (this.mismatchMode) {
              case ZipMismatchMode.FAIL:
                throw new Error("Zipped streams should have the same length. Mismatched at element " + this.count + ".");

              case ZipMismatchMode.SHORTEST:
                return [2, {
                  value: null,
                  done: !0
                }];

              case ZipMismatchMode.LONGEST:
            }
            return this.count++, [2, {
              value: o,
              done: !1
            }];
        }
      });
    });
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return this.currentPromise = this.nextState(this.currentPromise), [4, this.currentPromise];

          case 1:
            return [2, t.sent()];
        }
      });
    });
  }, r;
}(LazyIterator),
    PrefetchIterator = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.upstream = r, n.bufferSize = e, n.buffer = new RingBuffer(e), n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> Prefetch";
  }, r.prototype.refill = function () {
    for (; !this.buffer.isFull();) {
      var t = this.upstream.next();
      this.buffer.push(t);
    }
  }, r.prototype.next = function () {
    return this.refill(), this.buffer.shift();
  }, r;
}(LazyIterator),
    ShuffleIterator = function (t) {
  function r(r, e, n) {
    var o = t.call(this, r, e) || this;
    return o.upstream = r, o.windowSize = e, o.upstreamExhausted = !1, o.random = seedrandom_1(n || util.now().toString()), o.lastRead = Promise.resolve({
      value: null,
      done: !1
    }), o;
  }

  return __extends(r, t), r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;
      return __generator(this, function (r) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, r.prototype.randomInt = function (t) {
    return Math.floor(this.random() * t);
  }, r.prototype.chooseIndex = function () {
    return this.randomInt(this.buffer.length());
  }, r.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, r;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            this.upstreamExhausted || this.refill(), e.label = 1;

          case 1:
            return this.buffer.isEmpty() ? [3, 3] : (t = this.chooseIndex(), [4, this.buffer.shuffleExcise(t)]);

          case 2:
            return (r = e.sent()).done ? (this.upstreamExhausted = !0, [3, 1]) : (this.refill(), [2, r]);

          case 3:
            return [2, {
              value: null,
              done: !0
            }];
        }
      });
    });
  }, r;
}(PrefetchIterator),
    Dataset = function () {
  function t() {}

  return t.prototype.filter = function (t) {
    var r = this,
        e = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(r, void 0, void 0, function () {
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, e.iterator()];

            case 1:
              return [2, r.sent().filter(function (r) {
                return tidy(function () {
                  return t(r);
                });
              })];
          }
        });
      });
    });
  }, t.prototype.map = function (t) {
    var r = this,
        e = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(r, void 0, void 0, function () {
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, e.iterator()];

            case 1:
              return [2, r.sent().map(function (r) {
                return tidy(function () {
                  return t(r);
                });
              })];
          }
        });
      });
    });
  }, t.prototype.mapAsync = function (t) {
    var r = this,
        e = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(r, void 0, void 0, function () {
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, e.iterator()];

            case 1:
              return [2, r.sent().mapAsync(t)];
          }
        });
      });
    });
  }, t.prototype.batch = function (t, r) {
    var e = this;
    void 0 === r && (r = !0);
    var n = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, n.iterator()];

            case 1:
              return [2, e.sent().columnMajorBatch(t, r, deepBatchConcat)];
          }
        });
      });
    });
  }, t.prototype.concatenate = function (t) {
    var r = this,
        e = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(r, void 0, void 0, function () {
        var r, n;
        return __generator(this, function (o) {
          switch (o.label) {
            case 0:
              return [4, e.iterator()];

            case 1:
              return n = (r = o.sent()).concatenate, [4, t.iterator()];

            case 2:
              return [2, n.apply(r, [o.sent()])];
          }
        });
      });
    });
  }, t.prototype.repeat = function (t) {
    var r = this,
        e = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(r, void 0, void 0, function () {
        var r = this;
        return __generator(this, function (n) {
          return [2, iteratorFromConcatenated(iteratorFromFunction(function () {
            return __awaiter(r, void 0, void 0, function () {
              var t;
              return __generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return t = {}, [4, e.iterator()];

                  case 1:
                    return [2, (t.value = r.sent(), t.done = !1, t)];
                }
              });
            });
          }).take(t))];
        });
      });
    });
  }, t.prototype.take = function (t) {
    var r = this,
        e = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(r, void 0, void 0, function () {
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, e.iterator()];

            case 1:
              return [2, r.sent().take(t)];
          }
        });
      });
    });
  }, t.prototype.skip = function (t) {
    var r = this,
        e = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(r, void 0, void 0, function () {
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, e.iterator()];

            case 1:
              return [2, r.sent().skip(t)];
          }
        });
      });
    });
  }, t.prototype.shuffle = function (t, r, e) {
    var n = this;
    void 0 === e && (e = !0);
    var o = this,
        i = seedrandom_1(r || util.now().toString());
    return datasetFromIteratorFn(function () {
      return __awaiter(n, void 0, void 0, function () {
        var r;
        return __generator(this, function (n) {
          switch (n.label) {
            case 0:
              return r = i.int32(), e && (r += i.int32()), [4, o.iterator()];

            case 1:
              return [2, n.sent().shuffle(t, r.toString())];
          }
        });
      });
    });
  }, t.prototype.prefetch = function (t) {
    var r = this,
        e = this;
    return datasetFromIteratorFn(function () {
      return __awaiter(r, void 0, void 0, function () {
        return __generator(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, e.iterator()];

            case 1:
              return [2, r.sent().prefetch(t)];
          }
        });
      });
    });
  }, t.prototype.collectAll = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return [4, this.iterator()];

          case 1:
            return [2, t.sent().collect()];
        }
      });
    });
  }, t.prototype.forEach = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            return [4, this.iterator()];

          case 1:
            return [2, r.sent().forEach(t)];
        }
      });
    });
  }, t;
}();

function datasetFromIteratorFn(t) {
  return new (function (r) {
    function e() {
      return null !== r && r.apply(this, arguments) || this;
    }

    return __extends(e, r), e.prototype.iterator = function () {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (r) {
          return [2, t()];
        });
      });
    }, e;
  }(Dataset))();
}

function array(t) {
  var r = this;
  return datasetFromIteratorFn(function () {
    return __awaiter(r, void 0, void 0, function () {
      return __generator(this, function (r) {
        return [2, iteratorFromItems(t)];
      });
    });
  });
}

function zip(t) {
  var r = this;
  if (!isIterable(t)) throw new Error("The argument to zip() must be an object or array.");
  return datasetFromIteratorFn(function () {
    return __awaiter(r, void 0, void 0, function () {
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            return [4, deepMapAndAwaitAll(t, function (t) {
              if (t instanceof Dataset) return {
                value: t.iterator(),
                recurse: !1
              };
              if (isIterable(t)) return {
                value: null,
                recurse: !0
              };
              throw new Error("Leaves of the structure passed to zip() must be Datasets, not primitives.");
            })];

          case 1:
            return [2, iteratorFromZipped(r.sent(), ZipMismatchMode.SHORTEST)];
        }
      });
    });
  });
}

function deepBatchConcat(t) {
  if (null === t) return null;
  var r = t[0];
  return "string" == typeof r ? {
    value: t,
    recurse: !1
  } : isIterable(r) ? isNumericArray(r) ? {
    value: batchConcat(t),
    recurse: !1
  } : {
    value: null,
    recurse: !0
  } : {
    value: batchConcat(t),
    recurse: !1
  };
}

function batchConcat(t) {
  for (var r = shapeAndValues(t[0])[0], e = [t.length].concat(r), n = new Float32Array(e.reduce(function (t, r) {
    return t * r;
  })), o = 0, i = 0, s = t; i < s.length; i++) {
    var a = shapeAndValues(s[i]),
        u = a[0],
        h = a[1];
    if (!util.arraysEqual(u, r)) throw new Error("Elements must have the same shape to be batched");
    n.set(h, o), o += h.length;
  }

  return Tensor.make(e, {
    values: n
  });
}

function shapeAndValues(t) {
  return t instanceof Tensor ? [t.shape, t.dataSync()] : Array.isArray(t) ? [[t.length], t] : [[], [t]];
}

var TextLineDataset = function (t) {
  function r(r) {
    var e = t.call(this) || this;
    return e.input = r, e;
  }

  return __extends(r, t), r.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, r;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return [4, this.input.iterator()];

          case 1:
            return t = e.sent(), r = t.decodeUTF8(), [2, r.split("\n")];
        }
      });
    });
  }, r;
}(Dataset),
    CODE_QUOTE = '"',
    STATE_OUT = Symbol("out"),
    STATE_FIELD = Symbol("field"),
    STATE_QUOTE = Symbol("quote"),
    STATE_QUOTE_AFTER_QUOTE = Symbol("quoteafterquote"),
    STATE_WITHIN_QUOTE_IN_QUOTE = Symbol("quoteinquote"),
    CSVDataset = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.input = r, n.hasHeader = !0, n.fullColumnNames = null, n.columnNamesValidated = !1, n.columnConfigs = null, n.configuredColumnsOnly = !1, n.delimiter = ",", n.base = new TextLineDataset(r), e || (e = {}), n.hasHeader = !1 !== e.hasHeader, n.fullColumnNames = e.columnNames, n.columnConfigs = e.columnConfigs, n.configuredColumnsOnly = e.configuredColumnsOnly, n.delimiter = e.delimiter ? e.delimiter : ",", n;
  }

  return __extends(r, t), r.prototype.columnNames = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return this.columnNamesValidated ? [3, 2] : [4, this.setColumnNames()];

          case 1:
            t.sent(), t.label = 2;

          case 2:
            return [2, this.configuredColumnsOnly ? Object.keys(this.columnConfigs) : this.fullColumnNames];
        }
      });
    });
  }, r.prototype.setColumnNames = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, r, e, n, o, i;
      return __generator(this, function (s) {
        switch (s.label) {
          case 0:
            return [4, this.maybeReadHeaderLine()];

          case 1:
            if (t = s.sent(), !this.fullColumnNames && !t) throw new Error("Column names must be provided if there is no header line.");
            if (this.fullColumnNames && t && util.assert(t.length === this.fullColumnNames.length, "The length of provided columnNames (" + this.fullColumnNames.length.toString() + ") does not match the length of the header line read from file (" + t.length.toString() + ")."), this.fullColumnNames || (this.fullColumnNames = t), r = this.fullColumnNames.reduce(function (t, r) {
              return t[r] = t[r] + 1 || 1, t;
            }, {}), e = Object.keys(r).filter(function (t) {
              return r[t] > 1;
            }), util.assert(0 === e.length, "Duplicate column names found: " + e.toString()), this.columnConfigs) for (n = 0, o = Object.keys(this.columnConfigs); n < o.length; n++) {
              if (i = o[n], -1 === this.fullColumnNames.indexOf(i)) throw new Error('The key "' + i + '" provided in columnConfigs does not match any of the column names (' + this.fullColumnNames.toString() + ").");
            }
            return this.columnNamesValidated = !0, [2];
        }
      });
    });
  }, r.prototype.maybeReadHeaderLine = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (r) {
        switch (r.label) {
          case 0:
            return this.hasHeader ? [4, this.base.iterator()] : [3, 3];

          case 1:
            return [4, r.sent().next()];

          case 2:
            if ((t = r.sent()).done) throw new Error("No data was found for CSV parsing.");
            return [2, t.value.split(this.delimiter)];

          case 3:
            return [2, null];
        }
      });
    });
  }, r.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t,
          r = this;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return this.columnNamesValidated ? [3, 2] : [4, this.setColumnNames()];

          case 1:
            e.sent(), e.label = 2;

          case 2:
            return [4, this.base.iterator()];

          case 3:
            return t = e.sent(), this.hasHeader && (t = t.skip(1)), [2, t.map(function (t) {
              return r.makeDataElement(t);
            })];
        }
      });
    });
  }, r.prototype.makeDataElement = function (t) {
    for (var r = this.parseRow(t), e = {}, n = {}, o = 0; o < this.fullColumnNames.length; o++) {
      var i = this.fullColumnNames[o],
          s = this.columnConfigs ? this.columnConfigs[i] : null;

      if (!this.configuredColumnsOnly || s) {
        var a = r[o],
            u = null;
        if ("" === a) {
          if (s && void 0 !== s.default) u = s.default;else {
            if (s && (s.required || s.isLabel)) throw new Error("Required column " + i + " is empty in this line: " + t);
            u = void 0;
          }
        } else {
          var h = Number(a);
          if (isNaN(h)) u = s && "bool" === s.dtype ? this.getBoolean(a) : a;else if (s && s.dtype) switch (s.dtype) {
            case "float32":
              u = h;
              break;

            case "int32":
              u = Math.floor(h);
              break;

            case "bool":
              u = this.getBoolean(a);
              break;

            default:
              u = h;
          } else u = h;
        }
        s && s.isLabel ? n[i] = u : e[i] = u;
      }
    }

    return 0 === Object.keys(n).length ? e : [e, n];
  }, r.prototype.getBoolean = function (t) {
    return "1" === t || "true" === t.toLowerCase() ? 1 : 0;
  }, r.prototype.parseRow = function (t) {
    for (var r = [], e = 0, n = t.length, o = STATE_FIELD, i = 0; i < n; i++) {
      switch (o) {
        case STATE_OUT:
          switch (t.charAt(i)) {
            case CODE_QUOTE:
              e = i + 1, o = STATE_QUOTE;
              break;

            case this.delimiter:
              r.push(""), o = STATE_OUT, e = i + 1;
              break;

            default:
              o = STATE_FIELD, e = i;
          }

          break;

        case STATE_FIELD:
          switch (t.charAt(i)) {
            case this.delimiter:
              r.push(t.substring(e, i)), o = STATE_OUT, e = i + 1;
          }

          break;

        case STATE_QUOTE:
          switch (t.charAt(i)) {
            case CODE_QUOTE:
              o = STATE_QUOTE_AFTER_QUOTE;
          }

          break;

        case STATE_QUOTE_AFTER_QUOTE:
          switch (t.charAt(i)) {
            case this.delimiter:
              r.push(t.substring(e, i - 1)), o = STATE_OUT, e = i + 1;
              break;

            case CODE_QUOTE:
              o = STATE_QUOTE;
              break;

            default:
              o = STATE_WITHIN_QUOTE_IN_QUOTE;
          }

          break;

        case STATE_WITHIN_QUOTE_IN_QUOTE:
          switch (t.charAt(i)) {
            case CODE_QUOTE:
              o = STATE_QUOTE;
          }

      }
    }

    return o === STATE_QUOTE_AFTER_QUOTE ? r.push(t.substring(e, n - 1)) : r.push(t.substring(e)), r;
  }, r;
}(Dataset),
    DataSource = function () {
  return function () {};
}(),
    utf8 = createCommonjsModule(function (t, r) {
  !function (e) {
    var n = r,
        o = t && t.exports == n && t,
        i = "object" == typeof commonjsGlobal && commonjsGlobal;
    i.global !== i && i.window !== i || (e = i);
    var s,
        a,
        u,
        h = String.fromCharCode;

    function c(t) {
      for (var r, e, n = [], o = 0, i = t.length; o < i;) {
        (r = t.charCodeAt(o++)) >= 55296 && r <= 56319 && o < i ? 56320 == (64512 & (e = t.charCodeAt(o++))) ? n.push(((1023 & r) << 10) + (1023 & e) + 65536) : (n.push(r), o--) : n.push(r);
      }

      return n;
    }

    function l(t) {
      if (t >= 55296 && t <= 57343) throw Error("Lone surrogate U+" + t.toString(16).toUpperCase() + " is not a scalar value");
    }

    function f(t, r) {
      return h(t >> r & 63 | 128);
    }

    function p(t) {
      if (0 == (4294967168 & t)) return h(t);
      var r = "";
      return 0 == (4294965248 & t) ? r = h(t >> 6 & 31 | 192) : 0 == (4294901760 & t) ? (l(t), r = h(t >> 12 & 15 | 224), r += f(t, 6)) : 0 == (4292870144 & t) && (r = h(t >> 18 & 7 | 240), r += f(t, 12), r += f(t, 6)), r += h(63 & t | 128);
    }

    function d() {
      if (u >= a) throw Error("Invalid byte index");
      var t = 255 & s[u];
      if (u++, 128 == (192 & t)) return 63 & t;
      throw Error("Invalid continuation byte");
    }

    function y() {
      var t, r;
      if (u > a) throw Error("Invalid byte index");
      if (u == a) return !1;
      if (t = 255 & s[u], u++, 0 == (128 & t)) return t;

      if (192 == (224 & t)) {
        if ((r = (31 & t) << 6 | d()) >= 128) return r;
        throw Error("Invalid continuation byte");
      }

      if (224 == (240 & t)) {
        if ((r = (15 & t) << 12 | d() << 6 | d()) >= 2048) return l(r), r;
        throw Error("Invalid continuation byte");
      }

      if (240 == (248 & t) && (r = (7 & t) << 18 | d() << 12 | d() << 6 | d()) >= 65536 && r <= 1114111) return r;
      throw Error("Invalid UTF-8 detected");
    }

    var v = {
      version: "2.1.2",
      encode: function encode(t) {
        for (var r = c(t), e = r.length, n = -1, o = ""; ++n < e;) {
          o += p(r[n]);
        }

        return o;
      },
      decode: function decode(t) {
        s = c(t), a = s.length, u = 0;

        for (var r, e = []; !1 !== (r = y());) {
          e.push(r);
        }

        return function (t) {
          for (var r, e = t.length, n = -1, o = ""; ++n < e;) {
            (r = t[n]) > 65535 && (o += h((r -= 65536) >>> 10 & 1023 | 55296), r = 56320 | 1023 & r), o += h(r);
          }

          return o;
        }(e);
      }
    };
    if (n && !n.nodeType) {
      if (o) o.exports = v;else {
        var m = {}.hasOwnProperty;

        for (var w in v) {
          m.call(v, w) && (n[w] = v[w]);
        }
      }
    } else e.utf8 = v;
  }(commonjsGlobal);
}),
    utf8_1 = utf8.decode,
    StringIterator = function (t) {
  function r() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return __extends(r, t), r.prototype.split = function (t) {
    return new SplitIterator(this, t);
  }, r;
}(LazyIterator),
    SplitIterator = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.upstream = r, n.impl = new SplitIteratorImpl(r, e), n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.impl.summary();
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, this.impl.next()];
      });
    });
  }, r;
}(StringIterator),
    SplitIteratorImpl = function (t) {
  function r(r, e) {
    var n = t.call(this) || this;
    return n.upstream = r, n.separator = e, n.carryover = "", n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> Split('" + this.separator + "')";
  }, r.prototype.pump = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, r, e, n, o;
      return __generator(this, function (i) {
        switch (i.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            if ((t = i.sent()).done) return "" === this.carryover ? [2, !1] : (this.outputQueue.push(this.carryover), this.carryover = "", [2, !0]);

            for ((r = t.value.split(this.separator))[0] = this.carryover + r[0], e = 0, n = r.slice(0, -1); e < n.length; e++) {
              o = n[e], this.outputQueue.push(o);
            }

            return this.carryover = r[r.length - 1], [2, !0];
        }
      });
    });
  }, r;
}(OneToManyIterator),
    ByteChunkIterator = function (t) {
  function r() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return __extends(r, t), r.prototype.decodeUTF8 = function () {
    return new Utf8Iterator(this);
  }, r;
}(LazyIterator),
    Utf8Iterator = function (t) {
  function r(r) {
    var e = t.call(this) || this;
    return e.upstream = r, e.impl = new Utf8IteratorImpl(r), e;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.impl.summary();
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, this.impl.next()];
      });
    });
  }, r;
}(StringIterator),
    Utf8IteratorImpl = function (t) {
  function r(r) {
    var e = t.call(this) || this;
    return e.upstream = r, e.partial = new Uint8Array([]), e.partialBytesValid = 0, e;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return this.upstream.summary() + " -> Utf8";
  }, r.prototype.pump = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, r, e, n, o, i, s, a;
      return __generator(this, function (u) {
        switch (u.label) {
          case 0:
            return [4, this.upstream.next()];

          case 1:
            if ((t = u.sent()).done) {
              if (0 === this.partial.length) return [2, !1];
              r = new Uint8Array([]);
            } else r = t.value;

            for (e = this.partial.length - this.partialBytesValid, o = n = e, i = 0; n < r.length;) {
              o = n, i = utfWidth(r[n]), n = o + i;
            }

            return n === r.length && (o = n), s = utf8_1(String.fromCharCode.apply(null, r.slice(e, o))), e > 0 ? (this.partial.set(r.slice(0, e), this.partialBytesValid), a = utf8_1(String.fromCharCode.apply(null, this.partial)), this.outputQueue.push(a + s)) : this.outputQueue.push(s), o === r.length ? (this.partial = new Uint8Array([]), this.partialBytesValid = 0) : (this.partial = new Uint8Array(new ArrayBuffer(i)), this.partial.set(r.slice(o), 0), this.partialBytesValid = r.length - o), [2, !0];
        }
      });
    });
  }, r;
}(OneToManyIterator);

function utfWidth(t) {
  return t >= 252 ? 6 : t >= 248 ? 5 : t >= 240 ? 4 : t >= 224 ? 3 : t >= 192 ? 2 : 1;
}

var FileChunkIterator = function (t) {
  function r(r, e) {
    void 0 === e && (e = {});
    var n = t.call(this) || this;
    return n.file = r, n.options = e, util.assert(r instanceof Uint8Array || !!ENV.get("IS_BROWSER") && (r instanceof File || r instanceof Blob), "FileChunkIterator only supports File, Blob and Uint8Array right now."), n.offset = e.offset || 0, n.chunkSize = e.chunkSize || 1048576, n;
  }

  return __extends(r, t), r.prototype.summary = function () {
    return "FileChunks " + this.file;
  }, r.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t,
          r,
          e = this;
      return __generator(this, function (n) {
        switch (n.label) {
          case 0:
            return this.offset >= (this.file instanceof Uint8Array ? this.file.byteLength : this.file.size) ? [2, {
              value: null,
              done: !0
            }] : (t = new Promise(function (t, r) {
              var n = e.offset + e.chunkSize;
              if (e.file instanceof Uint8Array) t(new Uint8Array(e.file.slice(e.offset, n)));else {
                var o = new FileReader();
                o.onload = function (e) {
                  var n = o.result;
                  if (n instanceof ArrayBuffer && (n = new Uint8Array(n)), !(n instanceof Uint8Array)) return r(new TypeError("FileReader returned unknown type."));
                  t(n);
                }, o.onabort = function (t) {
                  return r(new Error("Aborted"));
                }, o.onerror = function (t) {
                  return r(new Error(t.type));
                };
                var i = e.file.slice(e.offset, n);
                o.readAsArrayBuffer(i);
              }
              e.offset = n;
            }), r = {}, [4, t]);

          case 1:
            return [2, (r.value = n.sent(), r.done = !1, r)];
        }
      });
    });
  }, r;
}(ByteChunkIterator);

function urlChunkIterator(t, r) {
  return void 0 === r && (r = {}), __awaiter(this, void 0, void 0, function () {
    var e, n, o;
    return __generator(this, function (i) {
      switch (i.label) {
        case 0:
          return ENV.get("IS_BROWSER") ? [4, fetch(t)] : [3, 5];

        case 1:
          return (e = i.sent()).ok ? [4, e.blob()] : [3, 3];

        case 2:
          return n = i.sent(), [2, new FileChunkIterator(n, r)];

        case 3:
          throw new Error(e.statusText);

        case 4:
          return [3, 9];

        case 5:
          if ("string" != typeof t) throw new Error("URL must be a string. Request objects are not supported in the node.js environment yet.");
          return [4, nodeFetch(t)];

        case 6:
          return (e = i.sent()).ok ? [4, e.buffer()] : [3, 8];

        case 7:
          return o = i.sent(), [2, new FileChunkIterator(o, r)];

        case 8:
          throw new Error(e.statusText);

        case 9:
          return [2];
      }
    });
  });
}

var URLDataSource = function (t) {
  function r(r, e) {
    void 0 === e && (e = {});
    var n = t.call(this) || this;
    return n.url = r, n.fileOptions = e, n;
  }

  return __extends(r, t), r.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, urlChunkIterator(this.url, this.fileOptions)];
      });
    });
  }, r;
}(DataSource);

function csv(t, r) {
  return void 0 === r && (r = {}), new CSVDataset(new URLDataSource(t), r);
}

var FileDataSource = function (t) {
  function r(r, e) {
    void 0 === e && (e = {});
    var n = t.call(this) || this;
    return n.input = r, n.options = e, n;
  }

  return __extends(r, t), r.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, new FileChunkIterator(this.input, this.options)];
      });
    });
  }, r;
}(DataSource),
    version = "0.1.2";

export { array, Dataset, datasetFromIteratorFn, zip, CSVDataset, TextLineDataset, csv, FileDataSource, URLDataSource, version as version_data };